import { useCallback } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import { rem } from 'polished'

import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaHoverable } from 'lib/theme/mediaQueries'

const Root = styled(Clickable)`
  height: ${rem(44)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  transition: background-color 0.2s;
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${rem(12)};
  padding-top: ${rem(4)};

  &.selected {
    background-color: ${props => props.theme.palette.highlight.primary.normalBackground};
  }

  &.in-range-date {
    background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  }

  &.single-day-range {
    background-color: ${props => props.theme.palette.highlight.primary.normalActive};
    color: ${props => props.theme.palette.highlight.primary.normalContrast};
  }

  &:disabled {
    color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }

  &.center-align {
    padding-top: 0;
    align-items: center;
  }

  &:not(:disabled):not(.selected-date) {
    ${mediaHoverable} {
      &:hover {
        background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
        color: ${props => props.theme.palette.neutral.surface.normalContrast};
      }
    }
    &:focus {
      background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
  }
`

interface Props extends Utils.PropsWithDataAttributes {
  day: Date
  selected: boolean
  disabled: boolean
  isInRange: boolean
  isSingleDayRange: boolean
  onClick: (day: Date) => void
}

function SearchDatePickerDay(props: Props) {
  const { day, disabled, selected, isInRange, isSingleDayRange, onClick, ...rest } = props

  const onSelectDay = useCallback(() => {
    onClick(day)
  }, [day, onClick])

  return (
    <Root
      onClick={onSelectDay}
      disabled={disabled}
      className={clsx({
        selected,
        'in-range-date': isInRange,
        'single-day-range': isSingleDayRange,
      }, 'center-align')}
    >
      <BodyText {...rest} variant="medium">
        {day.getDate()}
      </BodyText>
    </Root>
  )
}

export default SearchDatePickerDay
